export var TransactionQueueStatus;
(function (TransactionQueueStatus) {
    TransactionQueueStatus["GENERATED"] = "GENERATED";
    TransactionQueueStatus["PENDING_APPROVAL"] = "PENDING_APPROVAL";
    TransactionQueueStatus["APPROVED"] = "APPROVED";
    TransactionQueueStatus["PROCESSING"] = "PROCESSING";
    TransactionQueueStatus["COMPLETED"] = "COMPLETED";
    TransactionQueueStatus["FAILED"] = "FAILED";
    TransactionQueueStatus["CANCELED"] = "CANCELED";
})(TransactionQueueStatus || (TransactionQueueStatus = {}));
export var GenerationRunTriggerType;
(function (GenerationRunTriggerType) {
    GenerationRunTriggerType["SCHEDULED"] = "SCHEDULED";
    GenerationRunTriggerType["MANUAL"] = "MANUAL";
    GenerationRunTriggerType["CATCH_UP"] = "CATCH_UP";
})(GenerationRunTriggerType || (GenerationRunTriggerType = {}));
//# sourceMappingURL=transaction-queue.types.js.map